<template>
	<div>
    <Form ref="modifyPwdForm" :model="userVo" :rules="rules" :label-width="110" >
			<Row :gutter="10">
				<Col span="24">
				<FormItem label="原密码：" prop="oldPassword">
					<Input type="password" placeholder="密码格式为10-16字母、数字或特殊字符" v-model="userVo.oldPassword">
					</Input>
				</FormItem>
				</Col>
			</Row>
			<Row :gutter="10">
				<Col span="24">
				<FormItem label="新密码：" prop="password">
					<Input type="password" placeholder="密码格式为10-16字母、数字或特殊字符" v-model="userVo.password">
					</Input>
				</FormItem>
				</Col>
			</Row>
			<Row :gutter="10">
				<Col span="24">
				<FormItem label="确认密码：" prop="confirmPassword">
					<Input type="password" v-model="userVo.confirmPassword">
					</Input>
				</FormItem>
				</Col>
			</Row>
		</Form>
	</div>
</template>

<script>
	var not = /^\s+|\s+$/g;
	var passwordReg = /^[a-z0-9A-Z`~!@#$%^&*()_+\-={}\[\]:\";'<>?.,\/\|\\]{10,16}$/;
	                   
	export default {
		name: "modifyPwd",
		props: ['userId'],
		data() {
			var validatePassword = (rule, value, callback) => {
				var filedName = "密码";
				if(rule && rule.field){
					if(rule.field==="oldPassword"){
						filedName = "原密码";
					}else if(rule.field==="password"){
						filedName = "新密码";
					}
				}
				if(value == undefined || value == null || value === '') {
					callback(new Error('请填写' + filedName));
				} else {
					var password = value.toString().replace(not, "");
					if(password == undefined || password === '') {
						callback(new Error('请填写' + filedName));
					} else if(!passwordReg.test(password)){
						callback(new Error('格式不正确，请输入10-16字母、数字或特殊字符'));
					} else {
						callback();
					}
				}
			};
			var validateConfirmPassword = (rule, value, callback) => {
				if(value == undefined || value == null || value === '') {
					callback(new Error('请填写确认密码'));
				} else {
					var confirmPassword = value.toString().replace(not, "");
					this.userVo.confirmPassword = confirmPassword;
					if(confirmPassword == undefined || confirmPassword === '') {
						callback(new Error('请填写确认密码'));
					} else if(this.userVo.password!=confirmPassword){
						callback(new Error('两次输入的密码不一致'));
					} else {
						callback();
					}
				}
			};
			return {
				userVo:{
					id: 0,
					oldPassword: '',
					password: '',
					confirmPassword: ''
				},
				rules: {
					oldPassword: [{
						required: true,
						validator: validatePassword,
						trigger: 'blur'
					}],
					password: [{
						required: true,
						validator: validatePassword,
						trigger: 'blur'
					}],
					confirmPassword: [{
						required: true,
						validator: validateConfirmPassword,
						trigger: 'blur'
					}]
				}
			}
		},
		methods: {
			initData(){
				this.userVo = {
					id: 0,
					oldPassword: '',
					password: '',
					confirmPassword: ''
				};
			},
			submitForm(){
				this.$refs.modifyPwdForm.validate(valid=>{
					if(valid){
						this.userVo.id=this.userId;
						this.$http.put(this.$apiPrifixUri + "/user/pwdModification", this.userVo).then(res=>{
							if (res.code == 0) {
								this.$emit('modifyPwdToParent', false);
								this.$Message.info("修改密码成功！");
							}else{
								this.$Message.info(res.message);
							}
						}).catch((error) => {
							this.$Message.error('请求出错！');
						});
					}
				});
			}
		},
		mounted() {
		},
		computed: {
		},
		watch: {
    }
	}
</script>

<style>
  .ivu-input {
		width:100%;
	}
  .address-select .ivu-col-span-8{
    width:31.2%;
  }
</style>


// WEBPACK FOOTER //
// src/components/header/ModifyPwd.vue